RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const Alert = views.Alert = Marionette.LayoutView.extend({
        regions: {
            body: '.alert-body'
        },
        events: {
            'click button.close': 'dismiss'
        },
        className: 'alert fade in',
        attributes: {
            role: 'alert'
        },
        template: '#shellAlertTemplate',
        templateHelpers: function () {

            const me = this;
            const model = me.model;
            const config = model.get('config');
            let message = '';

            if (_.isString(config)) {

                message = config;
            } else if (_.isObject(config) && _.has(config, 'message')) {

                message = config.message;
            }

            const result = {
                message: message
            };

            return result;
        },
        onRender: function () {

            const me = this;
            const model = me.model;
            let autoDestructDelay;
            const type = model.get('type');

            me.$el.addClass(`alert-${type}`);

            autoDestructDelay = parseInt(model.get('autoDestructDelay'));

            if (isNaN(autoDestructDelay)) {

                autoDestructDelay = 1000 * 5;
            }

            me.showMessage();

            if (autoDestructDelay !== -1) {
                _.delay(_.bind(me.dismiss, me), autoDestructDelay);
            }
        },
        showMessage: function () {

            const me = this;
            const model = me.model;
            const config = model.get('config');

            // do nothing if we already handled simple message cases
            if (!_.isObject(config)) {

                return;
            }

            let view;

            if (_.isFunction(config.render)) {

                view = config;
            } else if (_.has(config, 'template')) {

                view = new Marionette.ItemView({
                    events: config.events,
                    template: config.template,
                    model: new Backbone.Model(config.data || {})
                });
            } else {

                // do nothing if we already, or don't know how to handle it
                return;
            }

            me.body.show(view);
        },
        dismiss: function () {

            const me = this;

            me.$el.velocity('fadeOut', {
                duration: 1000,
                complete: _.bind(me.destroy, me)
            });
        }
    });

    Alert.type = {
        SUCCESS: 'success',
        INFO: 'info',
        WARNING: 'warning',
        DANGER: 'danger',
        ERROR: 'error'
    };

    Alert.typeDefinition = {};
    Alert.typeDefinition[Alert.type.SUCCESS] = {
        icon: 'check-circle'
    };
    Alert.typeDefinition[Alert.type.INFO] = {
        icon: 'info-circle'
    };
    Alert.typeDefinition[Alert.type.WARNING] = {
        icon: 'warning'
    };
    Alert.typeDefinition[Alert.type.DANGER] = {
        icon: 'warning'
    };
    Alert.typeDefinition[Alert.type.ERROR] = {
        icon: 'warning',
        view: views.ErrorAlert
    };

    Alert.createModelByType = function (type, config, overrides) {
        const definition = Alert.typeDefinition[type];

        if (!definition) {

            throw new Error(`unrecognized alert type: ${type}`);
        }

        if (!config) {

            throw new Error('unspecified alert config');
        }

        if (definition.view) {

            config = new definition.view({
                model: new Backbone.Model(config)
            });
        }

        const data = _.extend({
            type: type,
            config: config
        }, definition, overrides);

        const result = new Backbone.Model(data);

        return result;
    };

    Alert.createByType = function (type, config) {

        const model = Alert.createModelByType(type, config);

        const result = new Alert({
            model: model
        });

        return result;
    };

});
